import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { map, findIndex } from "lodash";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";

import { getClassNames } from "../../Js/Common";
import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";

const ClassList = () => {
  // Hooks
  const dispatch = useDispatch();

  // State
  const [classes, setClasses] = useState([]);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  let selectedClasses = useSelector(
    (state) => state.assignment.selectedClasses
  );

  useEffect(() => {
    const innerFunction = async () => {
      let temp = await getClassNames(userInfo.site_uuid);
      if (userInfo.class_assigned && userInfo.class_assigned.length > 0) {
        setClasses(
          temp.filter((val) => userInfo.class_assigned.indexOf(val.id) > -1)
        );
      } else {
        setClasses(temp);
      }
    };
    innerFunction();
  }, [userInfo]);

  // select class from list
  const selectClass = (obj) => {
    if (findIndex(selectedClasses, { id: obj.id }) == -1) {
      dispatch(assignmentSliceActions.addClass(obj));
    } else {
      dispatch(assignmentSliceActions.removeClass(obj.id));
    }
  };

  return (
    <FormControl fullWidth sx={{ mb: 1 }} size="small">
      {selectedClasses && (
        <Select
          value={selectedClasses}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          sx={{
            borderRadius: 5,
            borderColor: "#FFFFFF",
            backgroundColor: "#F5F5F5",
          }}
          multiple
          renderValue={(selected) => {
            console.log("selected", selected);
            return map(selected, "value").join(", ");
          }}
        >
          {classes &&
            classes.map((val, index1) => {
              return (
                <Grid container key={`${index1}_Class`}>
                  <Grid item xs={2}>
                    <Checkbox
                      checked={
                        findIndex(selectedClasses, {
                          id: val.id,
                        }) > -1
                      }
                      onClick={() => selectClass(val)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    sx={{ paddingTop: 0.8, cursor: "pointer" }}
                  >
                    <ListItemText
                      primary={val.value}
                      onClick={() => selectClass(val)}
                    />
                  </Grid>
                </Grid>
              );
            })}
        </Select>
      )}
    </FormControl>
  );
};

export default ClassList;
